import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/lib/i18n";
import { SectionLabel, Reveal } from "./Reveal";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="relative py-28 md:py-36 border-t border-white/10" data-testid="faq-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionLabel n="07">{t.faq.label}</SectionLabel>
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl mt-8 text-[var(--text)]">{t.faq.title}</h2>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-8">
          <Accordion type="single" collapsible defaultValue="q0" className="border-t border-white/10">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`q${i}`} className="border-white/10">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-base md:text-xl text-[var(--text)] hover:no-underline hover:text-[var(--gold)] transition-colors [&>svg]:text-[var(--gold)]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-[var(--muted)] leading-relaxed pr-8 pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
